<template>
  <div class="f--c">
    <span style="font-weight: 500;margin-right: 14px">{{ $t('publishEdit.ShippingMethod') }}</span>
    <el-input :placeholder="$t('publishEdit.selectContent')" slot="reference" :class="{redBorder: false}" class="shippingInput" v-model="shippingAllInfo" @focus="visible = true"></el-input>
    <el-dialog width="700" :visible.sync="visible" >
      <div class="Shipping_Method">
            <div class="f Shipping_Method_select">
                <div>
                    {{$t('publishEdit.ShippingFrom')}}
                    <el-select style="margin-left: 10px" v-model="ShippingFrom" :disabled="submitMode==='edit'" @change="value=> selectChange(value, 'from')">
                        <el-option :label="item.renderName" :value="item.warehouseCode" v-for="item in ShippingFromSelectList" :key="item.warehouseId"></el-option>
                    </el-select>
                </div>
                <div>
                    {{$t('publishEdit.ShippingTo')}}
                    <el-select style="margin-left: 10px" v-model="ShippingTo" filterable @change="value=> selectChange(value, 'to')" :class="{redBorder: !ShippingTo}">
                        <el-option :label="item.name" :value="item.code" v-for="item in ShippingToSelectList" :key="item.code"></el-option>
                    </el-select>
                </div>
            </div>
            <el-table
              :data="ShippingList"
              style="width: 100%"
              height="300"
              v-loading="loading">
              <el-table-column label="" width="50">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.checked" @change="value=> checkChange(value, scope.row)"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="channelNameEn" :label="$t('publishEdit.ShippingMethod')">
              </el-table-column>
              <el-table-column prop="estimatedFreight" :label="$t('publishEdit.ShippingCost')">
                <template slot-scope="scope">
                  {{ `${currency} ${scope.row.estimatedFreight}` }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('publishEdit.EstimatedDeliveryTime')" prop="deliveryTime">
              </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
              <el-button @click="visible = false">{{ $t('publishEdit.cancel')}}</el-button>
              <el-button type="primary" @click="submit">{{ $t('publishEdit.confirm')}}</el-button>
            </div>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
export default {
  props: {
    currency: {
      type: String,
      default: () => ''
    },
    defaultReceivingCountry: {
      type: String,
      default: () => ''
    },
    detailObj: {
      type: Object,
      default: () => ({})
    },
    submitMode: {
      type: String,
      default: () => 'add'
    }
  },
  data() {
    return {
      ShippingFrom: '',
      ShippingTo: 'US',
      visible: false,
      ShippingToSelectList: [],
      loading: false,
      ShippingFromSelectList: [],
      ShippingList: []
    }
  },
  created() {
  },
  computed: {
    shippingAllInfo() {
      const ShippingWay = this.ShippingList.find(e => e.checked)
      let str = `${ShippingWay ? ShippingWay.channelNameEn : ''}`
      return str
    }
  },
  methods: {
    selectChange(value, which, first) {
      if (which === 'from') {
        this.$emit('warehouseChange', value)
      }
      let from = this.ShippingFromSelectList.find(e => e.warehouseCode === this.ShippingFrom)
      const params = this.getChannelParams({ from, termini: this.ShippingTo })
      params && this.publishGetChannel(params)
    },
    getChannelParams(value) {
      let params
      if (value.from && value.termini) {
        const { from } = value
        const { warehouseCode, warehouseId, warehouseType: channelGrouping } = from
        params = {
          warehouses: [{
            warehouseCode,
            termini: value.termini,
            channelGrouping,
            warehouseId,
            products: [{
              skuCode: this.detailObj.variants[0].skuCode,
              quantity: 1,
              kkProductId: this.detailObj.kkProductId
            }]
          }],
          currency: this.currency
        }
      }
      return params
    },
    // 获取物流信息
    publishGetChannel(params) {
      this.loading = true
      API.publishGetChannel(params).then(res => {
        if (res.data[0].code === 10000) {
          res.data[0].data.forEach(e => {
            this.$set(e, 'checked', false)
          })
          this.ShippingList = res.data[0].data
          // 默认勾选第一个  并把运费赋值
          this.$set(this.ShippingList[0], 'checked', true)
          // this.$emit('submit', this.ShippingList[0], true)
        } else {
          this.$message.error(res.data[0].message)
          this.ShippingList = []
        }
      }).finally(() => {
        this.loading = false
      })
    },
    checkChange(value, row) {
      this.ShippingList.forEach(e => {
        e.checked = false
      })
      row.checked = true
    },
    show() {
      this.visible = true
    },
    submit() {
      let target = this.ShippingList.find(e => e.checked)
      if (target) {
        this.$emit('submit', target)
        this.visible = false
      } else this.$message.error(this.$t('publishEdit.LogisticsError'))
    },
    // 更改仓库  重新获取国家列表
    setShippingFrom(value) {
      this.ShippingFrom = value
      // 根据仓库获取国家列表
      API.getSelectList({
        type: 7,
        param: this.ShippingFrom
      }).then(result => {
        let arr = result.data.sort((a, b) => a.name.charCodeAt(0) - b.name.charCodeAt(0))
        this.ShippingToSelectList = arr
        // 确保 this.detailObj.logistics 不为空后再访问属性
        if (this.detailObj.logistics) {
          this.ShippingTo = this.detailObj.logistics.receivingCountryCode || (this.defaultReceivingCountry || 'US')
        } else {
          // 处理 this.detailObj.logistics 为空的情况，设置默认值或采取其他操作
          this.ShippingTo = this.defaultReceivingCountry || 'US'
        }
      })
    },
    setShippingFromSelectList(ShippingFromSelectList) {
      this.ShippingFromSelectList = ShippingFromSelectList
    },
    // 设置收货地
    setShippingTo(value) {
      this.ShippingTo = value
    },
    // 获取缓存数据
    getlogistics() {
      let from = this.ShippingFromSelectList.find(e => e.warehouseCode === this.ShippingFrom) || {}
      let to = this.ShippingToSelectList.find(e => e.code === this.ShippingTo) || {}
      let channelObj = this.ShippingList.find(e => e.checked) || {}
      let final = true
      const { countryCode: shippingCountryCode = null, countryCn: shippingCountryName = null, warehouseCode = null, warehouseName = null, warehouseId = null, warehouseType = null } = from
      const { code: receivingCountryCode = null, name: receivingCountryName = null } = to
      const { channelCode = null, channelName = null } = channelObj
      let logistics = {
        shippingCountryCode,
        shippingCountryName,
        warehouseCode,
        warehouseName,
        warehouseId,
        warehouseType,
        receivingCountryCode,
        receivingCountryName,
        channelCode,
        channelName
      }
      if (final) final = logistics
      return final
    },
    setLoad(loading) {
      this.loading = loading
    },
    setList(arr) {
      this.ShippingList = arr
    },
    setShippingList(list, code) {
      this.ShippingList = list
      this.ShippingList.find(e => e.channelCode === code).checked = true
    },
    getChannelForTaskNo() {
      return new Promise((resolve, reject) => {
        let from = this.ShippingFromSelectList.find(e => e.warehouseCode === this.ShippingFrom)
        const params = this.getChannelParams({ from, termini: this.ShippingTo })
        API.publishGetChannel(params).then(res => {
          if (res.data[0].code === 10000) {
            res.data[0].data.forEach(e => {
              this.$set(e, 'checked', false)
            })
            this.ShippingList = res.data[0].data
            // 默认勾选第一个  并把运费赋值
            this.$set(this.ShippingList[0], 'checked', true)
            resolve(this.ShippingList[0].estimatedFreight)
          } else {
            this.$message.error(res.data[0].message)
            reject()
          }
        })
      })
    }
  }
}
</script>

  <style lang="scss" scoped>
  .Shipping_Method {
      .Shipping_Method_select {
        margin-bottom: 10px;
          > div {
              flex: 1;
          }
      }
  }
  .dialog-footer {
    text-align: right;
    padding-top: 10px;
  }
  .shippingInput {
    width: 300px;
  }
  // .shippingInput:hover {
  //   width: 300px;
  // }
  .redBorder {
    /deep/input {
      border-color: red;
    }

  }
  .requiredLabel::before {
      content: '*';
      color: #F56C6C;
      margin-right: 4px;
  }
  .maxheight {
    max-height: 400px;
    overflow-y: scroll;
  }
  </style>

